import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BannerService } from 'src/app/services/banner.service';
import { ProductService } from 'src/app/services/product.service';
import { LazyLoadEvent } from 'primeng/api';
import { RoleService } from 'src/app/services/role.service';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})

export class productComponent implements OnInit {
  public comingSoonMsg = environment.comingSoonMsg;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public cmsContent;
  public cmsContentData;
  public bannerList: any[];
  public webBannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  public loading: boolean;
  public errorMessage: string;
  public totalRecords = 0;
  private lazyLoadEvent: LazyLoadEvent;
  pricerangeform: FormGroup;
  public pagination = environment.pagination;
  public product_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',

    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    mousewheel: false,
    slidesPerView: 'auto',
    //pagination: false,
    // pagination: {
    //   el: ".swiper-pagination",
    //   dynamicBullets: true,
    //   clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }

  };
  products: any[] = [];
  categorys: any[] = [];
  sellers: any[] = [];
  startPrice: any[] = [];
  endPrice: any[] = [];
  public minvalue: any = null;
  public maxvalue: any = null;
  productPriceSubmitted: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private bannerService: BannerService,
    private productService: ProductService,
    private router: Router,
    private formBuilder: FormBuilder,
    private changeDetectorRef: ChangeDetectorRef,
    private roleService: RoleService,
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  validateMinMaxValues(formGroup: FormGroup) {
    const minvalue = formGroup.get('minvalue').value;
    const maxvalue = formGroup.get('maxvalue').value;

    if (minvalue !== null && maxvalue !== null && minvalue > maxvalue) {
      formGroup.get('minvalue').setErrors({ 'invalidRange': true });
      formGroup.get('maxvalue').setErrors({ 'invalidRange': true });
    } else if (minvalue !== null && maxvalue !== null && minvalue <= maxvalue) {
      formGroup.get('minvalue').setErrors(null);
      formGroup.get('maxvalue').setErrors(null);
    }
  }

  ngOnInit() {
    this.roleService.setCurrentActiveRoute(this.router.url);
    this.getBanner();
    //this.getProducts();
    this.pricerangeform = this.formBuilder.group({
      minvalue: [null, [Validators.min(0), Validators.required]],
      maxvalue: [null, [Validators.min(0), Validators.required]],
    }, { validator: this.validateMinMaxValues });
    this.loadProducts(this.lazyLoadEvent);
  }

  loadProducts(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 9;
    let query = "?filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 9;
      }
    }
    if(this.minvalue >0 && this.maxvalue >0){
      query +="&filterByMaxPrice="+this.maxvalue+"&filterByMinPrice="+this.minvalue;
    }  
    // alert(this.stateCode);
    // alert(this.cityName);

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;

    this.productService.getProductList(query).subscribe(
      data => {
        window.scroll(0, 0);
        //console.log("xxx", data);
        this.loading = false;
        this.products = data.data.items;
        this.totalRecords = data.data.totalCount;
        console.warn(this.totalRecords);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    )
  }

  brandlink() {
    this.router.navigate(["/"])
  }
  sellerlink() {
    this.router.navigate(["/"])
  }

  gofilterlink() {
    this.router.navigate(["/"])
  }

  searchByPriceFilter() {
    //this.router.navigate(["/"])
    this.productPriceSubmitted = true
    if (this.pricerangeform.invalid) {
      return;
    }
    this.minvalue = this.pricerangeform.value["minvalue"];
    this.maxvalue = this.pricerangeform.value["maxvalue"];
    if(this.minvalue >0 && this.maxvalue >0){
      //this.getProducts();
      this.loadProducts(this.lazyLoadEvent)
    }
  }
  get productPrice() {
    return this.pricerangeform.controls;
  }
  SellerFilter() {
    this.router.navigate(["/"])
  }
  CategoryFilter() {
    this.router.navigate(["/"])

  }

  ShortingFilter() {
    this.router.navigate(["/"])
  }
  getProducts() {
    let query = "?filterByDisable=false&filterByStatus=true";
    if(this.minvalue >0 && this.maxvalue >0){
      query +="&filterByMaxPrice="+this.maxvalue+"&filterByMinPrice="+this.minvalue;
    }    
    this.productService.getProductList(query).subscribe(
      data => {
        this.loading = false;
        this.products = data.data.items;
        //console.log(this.products);
        this.totalRecords = data.data.totalCount;
        // this.bannerList.forEach(element => {
        //   this.bannerImageList = element.banner_image;
        // });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  clear(mode) {
    if (mode == "price") {
      this.pricerangeform.reset();
      this.changeDetectorRef.detectChanges();
      this.minvalue = '';
      this.maxvalue = '';
      
    }
    
    //this.getProducts();
    this.loadProducts(this.lazyLoadEvent)
  }
  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=shop";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
        this.webBannerImageList = element.banner_image;
        this.mobileBannerImageList = element.mobile_banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
}
